import { ConfigitAutocomplete } from '../ConfigitAutocomplete/ConfigitAutocomplete';
import { jsx as _jsx } from "react/jsx-runtime";
export var ConfigitTextFieldProduct = function (_a) {
    var id = _a.id, label = _a.label, disabled = _a.disabled, options = _a.options, select = _a.select, unSelect = _a.unSelect;
    var preSelected = options.find(function (option) { return option.assigned; });
    if (!preSelected)
        preSelected = {};
    var handleSelect = function (value) { if (id)
        select(id, value); };
    var handleUnSelect = function () { if (id)
        unSelect(id); };
    return /*#__PURE__*/ _jsx(ConfigitAutocomplete, { id: id, label: label, disabled: disabled, options: options, preSelectedOption: preSelected, handleSelect: handleSelect, handleUnSelect: handleUnSelect });
};
